/*global self*/
/*eslint-disable no-unused-expressions */
/*eslint-disable no-new-func */
/*eslint-disable no-unused-vars */
/*eslint-disable no-self-compare */
/*eslint-disable no-use-before-define */
/*eslint-disable no-redeclare */
/*eslint-disable no-loop-func */
/*eslint-disable new-parens */
/*eslint-disable eqeqeq */
/*eslint-disable default-case */
/*eslint no-unused-expressions: ["error", { "allowTernary": true }]*/
/*eslint no-restricted-globals: ["off", "self"]*/
/*eslint no-undef: "off"*/

// TinyColor v1.4.1
// https://github.com/bgrins/TinyColor
// Brian Grinstead, MIT License

const TinyColor = require('../TinyColor/TinyColor');

;(function() {
  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;
  /** Used as the semantic version number. */
  var VERSION = '2.0';
  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();
  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  function Mv2 (color, opts) {
  }
  
  Mv2.prototype = {
  };

  Mv2.Color = TinyColor;
  Mv2.Color.prototype.getTextWB = function({ light = "#000000", dark = "#ffffff" } = {}) {
    let _l = light;
    let _d = dark;
    return this.isLight() == true ? _l : _d;
  }
  Mv2.VERSION = VERSION;
  
  // Node: Export function
  if (typeof module !== "undefined" && module.exports) {
      module.exports = Mv2;
  }
  // AMD/requirejs: Define the module
  else if (typeof define === 'function' && define.amd) {
      define(function () {return Mv2;});
  }
  // Browser: Expose to window
  else {
      window.Mv2 = Mv2;
  }
})();